import request from '@/utils/request'

// 首页banner列表
export const getBannerList = (params)=>{
  return request({
    url: `/api/banner/page`,
    params,
    method: "get"
  });
}

// 筛选分类
export const getClassifyList = (params)=>{
  return request({
    url: `/api/classify/list`,
    params,
    method: "get"
  });
}

// 首页推荐列表
export const getHomeList = (params)=>{
  return request({
    url: `/api/product/isHomeList`,
    params,
    method: "get"
  });
}

// 合作伙伴列表
export const getPartnersList = (params)=>{
  return request({
    url: `/api/coop/page`,
    params,
    method: "get"
  });
}

// 内容管理列表
export const getContentList = (params)=>{
  return request({
    url: `/api/content/page`,
    params,
    method: "get"
  });
}



// WEBPACK FOOTER //
// ./src/api/home.js